import { render } from "./UserWifiActive.vue?vue&type=template&id=2424143c&scoped=true"
import script from "./UserWifiActive.vue?vue&type=script&lang=js"
export * from "./UserWifiActive.vue?vue&type=script&lang=js"

import "./UserWifiActive.vue?vue&type=style&index=0&id=2424143c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2424143c"]])

export default __exports__